export const categories = [
  {
    id: 1,
    nombre: 'Cachimbas',
    imagen: '/img/resmoke/Cachimbas.png', // Ruta corregida
    descripcion: 'Cachimbas de alta calidad'
  },
  {
    id: 2,
    nombre: 'Cazoletas', 
    imagen: '/img/resmoke/Cazoletas.png',
    descripcion: 'Cazoletas para tu cachimba'
  },
  {
    id: 3,
    nombre: 'Mangueras',
    imagen: '/img/resmoke/Mangueras.png',
    descripcion: 'Mangueras de diferentes estilos'
  },
  {
    id: 4,
    nombre: 'Bases',
    imagen: '/img/resmoke/Bases.png',
    descripcion: 'Bases resistentes y elegantes'
  },
  {
    id: 5,
    nombre: 'Accesorios',
    imagen: '/img/resmoke/Accesorios.png',
    descripcion: 'Accesorios para completar tu setup'
  },
  {
    id: 6,
    nombre: 'Vapers',
    imagen: '/img/resmoke/Vapers.png',
    descripcion: 'Vapers de última generación'
  }
];

